import { ref } from "vue";

export function useFontsReady() {
  const ready = ref(false);
  document.fonts.ready.then(() => (ready.value = true));
  return ready;
}
